import React, { useEffect } from "react";
import {
  CustomView,
  MobileView,
  isTablet,
  isMobile,
  useMobileOrientation,
} from "react-device-detect";

export default function MobileViewGlobal({
  children,
  className = null,
  ...rest
}) {
  return (
    <CustomView
      {...rest}
      className={className}
      condition={isMobile | isTablet}
  
    >
      {children}
    </CustomView>
  );
}
